import { NotificationHelper, useNotification } from "@client/helpers/NotificationHelper";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { SnackbarProvider } from "notistack";
import { createRef, PropsWithChildren, useEffect, useSyncExternalStore } from "react";

export default function NotificationProvider({ children }: PropsWithChildren) {
    const notiStackRef = createRef<SnackbarProvider>();

    return <SnackbarProvider
        ref={notiStackRef}
        maxSnack={10}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        autoHideDuration={5000}
        dense
        action={key => (
            <IconButton key={key}
                style={{ color: "white" }}
                size="small"
                onClick={() => notiStackRef.current?.closeSnackbar(key)}
                children={<CloseIcon />}
            />
        )}
    >
        <NotificationResolver />
        {children}
    </SnackbarProvider>
}

function NotificationResolver() {
    const message = useSyncExternalStore(NotificationHelper.subscribe, NotificationHelper.getSnapshot);
    const notifier = useNotification();

    useEffect(() => {
        if (message != null) {
            const { variant, message: msg } = message;
            if (variant === "error") {
                notifier.error(msg);
            } else if (variant === "info") {
                notifier.info(msg);
            } else if (variant === "success") {
                notifier.success(msg);
            } else if (variant === "warning") {
                notifier.warn(msg);
            } else {
                notifier.log(msg);
            }
        }
    }, [message]);
    return null;
}